<button
  matButton="outlined"
  class="icon-button !tw-min-w-9"
  [matMenuTriggerFor]="creditsMenu"
  id="ai-chatbot-credits-menu-button"
  aria-label="Open AI credits menu"
>
  <mat-icon
    svgIcon="more-horizontal"
    class="!tw-m-0"
    aria-hidden="true"
  ></mat-icon>
</button>
<mat-menu #creditsMenu="matMenu">
  <div class="tw-p-4">
    <h4 class="tw-font-normal tw-text-gray-600 tw-mt-0 tw-text-[13px]">
      {{ companyName() }}
    </h4>
    <div class="tw-w-[248px] tw-bg-gray-100 tw-rounded-[5px] tw-mb-2 tw-p-3">
      <div class="tw-flex tw-flex-row tw-justify-between tw-items-center">
        <h3 class="tw-font-semibold tw-text-sm tw-m-0">Credits</h3>
        <p
          id="credits-remaining"
          class="tw-font-normal tw-text-gray-600 tw-m-0 tw-text-[13px]"
        >
          {{ creditsRemaining() }}
        </p>
      </div>
      <div class="tw-mt-4">
        <div
          class="tw-relative tw-w-full tw-h-2 tw-bg-gray-200 tw-rounded-full"
        >
          <div
            class="tw-absolute tw-top-0 tw-left-0 tw-h-full tw-rounded-full"
            [style.width]="creditsPercentage() + '%'"
            id="credits-percentage"
          ></div>
        </div>
      </div>
      <div class="tw-mt-4">
        <p
          id="total-monthly-credits"
          class="tw-font-normal tw-text-gray-600 tw-m-0 tw-text-[13px]"
        >
          Total monthly credits: {{ creditsTotal() }}
        </p>
        <p
          class="tw-font-normal tw-text-gray-600 tw-m-0 tw-text-[13px] tw-mt-1"
        >
          Credits reset at the start of each month.
        </p>
      </div>
    </div>
    <button rv-button class="tw-w-full" (click)="openCreditsModal()">
      Get More Credits
    </button>
  </div>
</mat-menu>
